import { inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivateFn,
  createUrlTreeFromSnapshot,
  RedirectCommand,
  Router,
} from '@angular/router';
import { UserInfoService } from '../../features/user/services/user-info.service';
import { UserInfoAuthorizationInformation } from '../clients/omni-core/models';

export const roleGuard =
  (
    acceptedRoles:
      UserInfoAuthorizationInformation['role'] | UserInfoAuthorizationInformation['role'][],
    redirectTo: string | false = '/',
  ): CanActivateFn =>
  (route: ActivatedRouteSnapshot): boolean | RedirectCommand => {
    const role = inject(UserInfoService).info()?.role;
    if (
      Array.isArray(acceptedRoles) ? acceptedRoles.some((r) => r === role) : acceptedRoles === role
    ) {
      return true;
    }

    if (redirectTo === false) {
      return false;
    }

    const router = inject(Router);
    const urlTree = route?.root
      ? createUrlTreeFromSnapshot(route, [redirectTo], route.queryParams)
      : router.parseUrl(redirectTo);

    return new RedirectCommand(urlTree);
  };
